import type { ServicesApiBackfill } from '@/services/api/services-api';
import type { BackfillComputed } from '../types';
import { getTaskTypeInfo, type BackfillType } from './task-types';

export function transformBackfill(backfill: ServicesApiBackfill): BackfillComputed {
  const info = getTaskTypeInfo(backfill.type as BackfillType);
  const isPending = !['Success', 'Failure', 'Canceled'].includes(backfill.state);

  return {
    ...backfill,
    isPending,
    info,
  };
}
